    async function checkCountry() {
        $iscookie = document.cookie.match(new RegExp('(^| )c_detector=([^;]+)'));

        if (!$iscookie) {
            var detectedCountry = await fetch('https://us.science4youtoys.com/browsing_context_suggestions.json').then(res => res.json()).then(r => r.detected_values.country.handle);


            
            switch (detectedCountry) {
                case 'US':
                case 'CA':
                    document.cookie = "c_detector=" + detectedCountry;
                    return 0;
                    break;

                case 'PT':
                    document.getElementById("modal_link").innerHTML = "No, go to Portuguese site";
                    document.getElementById("modal_link").setAttribute("href","https://www.science4you.pt/");
                    break;
                
                case 'ES':
                    document.getElementById("modal_link").innerHTML = "No, go to Spanish site";
                    document.getElementById("modal_link").setAttribute("href","https://www.science4you.es/");
                    break;

                case 'FR':
                    document.getElementById("modal_link").innerHTML = "No, go to French site";
                    document.getElementById("modal_link").setAttribute("href","https://www.science4youtoys.com/fr/");
                    break;

                case 'DE':
                    document.getElementById("modal_link").innerHTML = "No, go to German site";
                    document.getElementById("modal_link").setAttribute("href","https://www.science4youtoys.com/de/");
                    break;



                default:
                    document.getElementById("modal_link").innerHTML = "No, go to Internacional site";
                    document.getElementById("modal_link").setAttribute("href","https://www.science4youtoys.com/de/");
                    break;
            }
          document.getElementById("modal_redirect").style.display = "flex";

        }

    }

    checkCountry();



    async function stayHere() {
        var detectedCountry = await fetch('https://us.science4youtoys.com/browsing_context_suggestions.json').then(res => res.json()).then(r => r.detected_values.country.handle);
        document.cookie = "c_detector=" + detectedCountry;
        document.getElementById("modal_redirect").style.display = "none";
    }